import { gsap } from "gsap";

export class Cursor {
  constructor( wrap ) {
    this.wrap = wrap;
    this.el = this.wrap.querySelector( '.cursor' );
    this.itemsWrap = this.wrap.querySelector('.border-hover-items-wrap') ? this.wrap.querySelector('.border-hover-items-wrap') : this.wrap;
    this.target = [...this.wrap.querySelectorAll( '.border-hover-item' )];
    
    this.bind();
  }

  bind() {
    this.wrap.addEventListener( 'mousemove', this.move.bind( this ), false );
    this.itemsWrap && this.itemsWrap.addEventListener('mouseenter', () => !this.wrap.classList.contains('hover') && this.wrap.classList.add('hover'));
    this.itemsWrap && this.itemsWrap.addEventListener('mouseleave', () => this.wrap.classList.contains('hover') && this.wrap.classList.remove('hover'));
  }

  move( e ) {
    const cursorPosition = {
      left: e.clientX,
      top: e.clientY,
    }

    !this.el.classList.contains('expanded') && gsap.to( this.el, 0.3, {
      left: cursorPosition.left,
      top: cursorPosition.top,
    });

    this.target.forEach(target => {
      const targetParent = target.parentNode;
      const targetWidth = targetParent.getBoundingClientRect().width;
      const targetHeight = targetParent.getBoundingClientRect().height;
      const triggerDistance = ((targetHeight / 2) + (targetWidth / 2)) / 2 - 25;

      const targetPosition = {
        left: targetParent.getBoundingClientRect().left + targetWidth / 2,
        top: targetParent.getBoundingClientRect().top + targetHeight / 2,
      }

      const distance = {
        x: targetPosition.left - cursorPosition.left,
        y: targetPosition.top - cursorPosition.top,
      }

      const angle = Math.atan2( distance.x, distance.y );
      const hypotenuse = Math.sqrt( distance.x * distance.x + distance.y * distance.y );

      if( hypotenuse < triggerDistance ) {
        !this.el.classList.contains('expanded') && this.el.classList.add('expanded');
        !target.classList.contains('expanded') && target.classList.add('expanded');

        target.classList.contains('expanded') && gsap.to( this.el, 0.3, {
          left: targetPosition.left - Math.sin( angle ) * hypotenuse / 20,
          top: targetPosition.top - Math.cos( angle ) * hypotenuse / 20,
          width: targetWidth,
          height: targetHeight,
          borderRadius: '15px',
        });

        gsap.to( target, 0.2, {
          x: (Math.sin( angle ) * hypotenuse / 15) * -1,
          y: (Math.cos( angle ) * hypotenuse / 15) * -1,
        });
      } else {
        if (target.classList.contains('expanded') ) {
          gsap.to( this.el, 0.3, {
            left: cursorPosition.left,
            top: cursorPosition.top,
            width: 40,
            height: 40,
            borderRadius: '50%',
          });

          gsap.to( target, 0.3, {
            x: 0,
            y: 0,
          });

          this.el.classList.remove('expanded');
          target.classList.remove('expanded');
        }
      }
    });
  }
}
